import React from 'react';

const WrappedSelector = ({ label, name, children, onChange, value, width }) => (
  <div >
    {label && <label htmlFor={name}>{label}</label>}
    <select
      id={name}
      style={{ maxWidth: width, paddingRight: 28, textOverflow: 'ellipsis' }}
      onChange={event => {
        onChange(event.target.value);
        event.target.blur();
      }}
      className="form-control select__popup"
      value={value}
    >
      {children}
    </select>
  </div>
);

const SelectorOption = (option, index) => (
  <option key={index} value={option.syid || option.mpid || option.value || option.xp_key || option.idcathedra || option.idcurriculum || option.value || option.cid || 0}>
    {option.name || option.cathedra || option.cname || option.title || option.period}
  </option>
);

const Selector = ({ name, label, options, onChange, value, width }) => (
  <WrappedSelector
    onChange={onChange}
    name={name}
    label={label}
    width={width}
    value={value}
  >
    {options && options.map(SelectorOption)}
  </WrappedSelector>
);

export default Selector;
